import React from 'react';
import { useSelector } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import './BannerComponent.css';

const Banner = () => {
  const homeBannerText = useSelector((state) => state.HomeBannerText);
  const renderBannerText = () => {
    if (!homeBannerText || typeof homeBannerText !== 'string') return null;
    const parts = homeBannerText.split('*');
    if (parts.length >= 3) {
      return (
        <>
          {parts[0].replace(/^#+\s*/, '')}<span className="bannerSpan">{parts[1]}</span>{parts[2]}
        </>
      );
    }
    return homeBannerText;
  };

  return (
    <div className="container-fluid bg-white py-4" style={{color:'#000066'}}>
      <div className="row justify-content-center text-center">
        <div className="col-12">
          <h1 className="bannerHeding">
            {renderBannerText()}
          </h1>
        </div>
      </div>
    </div>
  );
};

export default Banner;
